/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import MsgBox from "../../../components/chatBox/MsgBox";
import { msgAction, roomAction } from "../../../../store/actions/MsgAction";
import { getRoomList } from "../../../../services/ChatService";
import formatError from "../../../../services/FormatError";
import avatar from "../../../../images/user.png";
function Chat(props) {
  const chat = useSelector((state) => state.chat);
  const msg = useSelector((state) => state.msg);
  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"));
  const [selectedTab, setSelectedTab] = useState("");
  const [roomList, setRoomList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState({});

  const dispatch = useDispatch();
  useEffect(() => {
    if (ctxObj.result.role.id === 3) {
      setSelectedTab("representatives");
    }
    if (ctxObj.result.role.id === 4) {
      setSelectedTab("buyers");
    }
    if (ctxObj.result.role.id === 5) {
      setSelectedTab("sellers");
    }
  }, []);
  useEffect(() => {
    if (selectedTab !== "") {
      getRooms();
    }
  }, [selectedTab, msg]);

  const getRooms = () => {
    setLoading(true);
    try {
      getRoomList(selectedTab)
        .then((res) => {
          const response = res.data?.result;
          if (response !== null) {
            setRoomList(response);
          } else {
            setRoomList([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const seenHandler = (roomId) => {
    if (props.readyState === 1) {
      const tempMessage = {
        type: "set_message_seen",
        payload: {
          roomid: roomId,
        },
      };
      props.sendMessage(JSON.stringify(tempMessage));

      getRooms();
    }
  };

  return (
    <div
      className={`tab-pane fade  ${chat ? "active show" : ""}`}
      id="chat"
      role="tabpanel"
    >
      <div
        className={`card mb-sm-3 mb-md-0 contacts_card dz-chat-user-box ${
          msg.isMsgOpen ? "d-none" : ""
        }`}
      >
        <div className="d-flex justify-content-center align-items-center card-header chat-list-header text-center">
          <div className="w-100 ">
            {ctxObj?.result?.role?.id === 3 &&
            (ctxObj?.result?.loggedinprofiletype === "buyerprofile" ||
              ctxObj?.result?.loggedinprofiletype === "sellerprofile") ? (
              <div className="d-flex justify-content-around">
                <h6
                  className={`mb-0  ${
                    selectedTab === "representatives"
                      ? `border-bottom border-2 border-primary`
                      : ``
                  }  `}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedTab("representatives");
                    getRooms();
                  }}
                >
                  Representative
                </h6>
                <h6
                  className={`mb-0  ${
                    selectedTab === "professionals"
                      ? `border-bottom border-2 border-primary`
                      : ``
                  }  `}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedTab("professionals");
                    getRooms();
                  }}
                >
                  Professional
                </h6>
              </div>
            ) : ctxObj?.result?.role?.id === 4 ? (
              <div className="d-flex justify-content-around">
                <h6
                  className={`mb-0  ${
                    selectedTab === "buyers"
                      ? `border-bottom border-2 border-primary`
                      : ``
                  }  `}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedTab("buyers");
                    getRooms();
                  }}
                >
                  Buyer
                </h6>
                <h6
                  className={`mb-0  ${
                    selectedTab === "sellers"
                      ? `border-bottom border-2 border-primary`
                      : ``
                  }  `}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedTab("sellers");
                    getRooms();
                  }}
                >
                  Seller
                </h6>
                {/* <h6
									className={`mb-0  ${
										selectedTab === "professional" ? `border-bottom border-2 border-primary` : ``
									}  `}
									style={{ cursor: "pointer" }}
									onClick={() => {
										setSelectedTab("professionals");
									}}
								>
									Professional
								</h6> */}
              </div>
            ) : (
              <div className="d-flex justify-content-between">
                {/* <h6
									className={`mb-0  ${
										selectedTab === "buyer" ? `border-bottom border-2 border-primary` : ``
									}  `}
									style={{ cursor: "pointer" }}
									onClick={() => {
										setSelectedTab("buyers");
										getRooms();
									}}
								>
									Buyer
								</h6> */}
                <h6
                  className={`mb-0  ${
                    selectedTab === "sellers"
                      ? `border-bottom border-2 border-primary`
                      : ``
                  }  `}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedTab("sellers");
                    getRooms();
                  }}
                >
                  Seller
                </h6>
                {/* <h6
									className={`mb-0  ${
										selectedTab === "representative" ? `border-bottom border-2 border-primary` : ``
									}  `}
									style={{ cursor: "pointer" }}
									onClick={() => {
										setSelectedTab("representatives");
										getRooms();
									}}
								>
									Representative
								</h6> */}
              </div>
            )}
          </div>

          {/* <Link to='#'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            xmlnsXlink='http://www.w3.org/1999/xlink'
                            width='18px'
                            height='18px'
                            viewBox='0 0 24 24'
                            version='1.1'
                        >
                            <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                                <rect x='0' y='0' width='24' height='24' />
                                <circle fill='#000000' cx='5' cy='12' r='2' />
                                <circle fill='#000000' cx='12' cy='12' r='2' />
                                <circle fill='#000000' cx='19' cy='12' r='2' />
                            </g>
                        </svg>
                    </Link> */}
        </div>

        <PerfectScrollbar
          className={`card-body contacts_body p-0 dz-scroll  ${
            chat ? "ps ps--active-y" : ""
          }`}
          id="DZ_W_Contacts_Body"
        >
          {loading ? (
            <div class="d-flex justify-content-center mt-5">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <ul className="contacts">
              {/* <li className='name-first-letter'>A</li> */}
              {roomList?.map((item, index) => (
                <li
                  className="active dz-chat-user d-flex justify-content-between align-items-center"
                  onClick={() => {
                    setSelectedUser(item?.user);
                    dispatch(roomAction(item?.id));
                    dispatch(msgAction(true));
                  }}
                  key={index}
                >
                  <div className="d-flex bd-highlight">
                    <div className="img_cont">
                      <img
                        src={item?.user?.photo || avatar}
                        className="rounded-circle user_img"
                        alt=""
                        style={{ height: "40px", width: "40px" }}
                      />
                      {/* <span className="online_icon"></span> */}
                    </div>
                    <div className="user_info">
                      <span>{item?.user?.name}</span>
                      <p>{item?.lastmessage?.message?.slice(0, 20)}...</p>
                    </div>
                  </div>
                  {item?.unseenmessagecnt > 0 && (
                    <p
                      className=" bg-primary px-2 rounded-circle text-white"
                      style={{
                        height: "25px",
                        width: "25px",
                        position: "absolute",
                        right: 10,
                        top: 10,
                      }}
                    >
                      {item?.unseenmessagecnt ?? 0}
                    </p>
                  )}
                </li>
              ))}

              {roomList?.length === 0 && (
                <p className="text-center mt-5" style={{ color: "#00000060" }}>
                  Chat History Empty
                </p>
              )}
            </ul>
          )}
        </PerfectScrollbar>
      </div>
      {msg.isMsgOpen && (
        <MsgBox
          openMsg={msg.isMsgOpen}
          PerfectScrollbar={PerfectScrollbar}
          offMsg={() => dispatch(msgAction(false))}
          lastMessage={props.lastMessage}
          sendMessage={props.sendMessage}
          user={ctxObj?.result}
          readyState={props.readyState}
          selectedUser={selectedUser}
          seenHandler={seenHandler}
        />
      )}
    </div>
  );
}

export default Chat;
